import { Action } from 'redux';

import { ImmigrationStatus, PrimeStatus, Profile } from '@src/types';

export const AUTH_SET_TOKENS = 'authentication/SetTokens';
export const AUTH_SET_PROFILE = 'authentication/SetProfile';
export const AUTH_SET_PRIME = 'authentication/SetPrime';
export const AUTH_SET_ACCESSES = 'authentication/SetAllAccess';
export const AUTH_SET_IMMIGRATION = 'authentication/SetImmigration';
export const AUTH_SET_REFRESHING = 'authentication/SetRefreshing';
export const AUTH_LOGOUT = 'authentication/Logout';
export const AUTH_SET_SETUP_COMPLETE = 'authentication/SetSetupComplete';
export const AUTH_SET_LABELS_FILLED = 'authentication/SetLabelsFilled';
export const AUTH_SET_LABELS = 'authentication/SetLabels';

export interface Tokens {
  accessToken: string;
  refreshToken: string;
  region?: string;
  userID?: string;
  profile?: Profile;
  prime?: PrimeStatus;
  allAccess?: PrimeStatus[];
  immigration?: ImmigrationStatus;
  refreshing?: boolean;
}

export interface Labels {
  labels?: number[];
  talents?: number[];
  travellingTypePreference?: 1 | 2;
  labelsText?: string[];
}
export interface SetAllStatusAction extends Action<typeof AUTH_SET_ACCESSES> {
  payload: PrimeStatus[];
}
export interface SetPrimeStatusAction extends Action<typeof AUTH_SET_PRIME> {
  payload: PrimeStatus;
}
export interface SetImmigrationStatusAction
  extends Action<typeof AUTH_SET_IMMIGRATION> {
  payload: ImmigrationStatus;
}
export interface SetTokensAction extends Action<typeof AUTH_SET_TOKENS> {
  payload: Tokens;
}

export interface SetProfileAction extends Action<typeof AUTH_SET_PROFILE> {
  payload: Profile;
}

export interface SetSetupCompleteAction
  extends Action<typeof AUTH_SET_SETUP_COMPLETE> {
  payload: boolean;
}

export interface SetLabelsFilledAction
  extends Action<typeof AUTH_SET_LABELS_FILLED> {
  payload: boolean;
}

export interface SetRefreshingAction
  extends Action<typeof AUTH_SET_REFRESHING> {
  payload: boolean;
}

export interface SetLabelsAction extends Action<typeof AUTH_SET_LABELS> {
  payload: Labels;
}

export interface LogoutAction extends Action<typeof AUTH_LOGOUT> {}

export type Actions =
  | SetTokensAction
  | SetProfileAction
  | SetPrimeStatusAction
  | SetImmigrationStatusAction
  | LogoutAction
  | SetLabelsFilledAction
  | SetSetupCompleteAction
  | SetLabelsAction
  | SetAllStatusAction
  | SetRefreshingAction;

export type State = Tokens & {
  setupComplete: boolean;
  labelsFilled: boolean;
  labels?: Labels;
};
